import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';

export const FinancialRecordsUploader = (props) => {
    const [totalSize, setTotalSize] = useState(0);
    const [filesToBeImported, setFilesToBeImported] = useState([]);
    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const ofx = require('node-ofx-parser');

    const parse = (file) => {
        // Always return a Promise
        return new Promise((resolve, reject) => {
          let content = '';
          const reader = new FileReader();
          // Wait till complete
          reader.onload = function(e) {
            resolve(e.target.result);
          };
          // Make sure to handle error states
          reader.onerror = function(e) {
            reject(e);
          };
          reader.readAsText(file);
        });
      };

    const analyseFile = (fileToBeImported) => {

        const errorMessage = {type: "danger", icon: "pi-times-circle"};
        const waringMessage = {type: "warning", icon: "pi-exclamation-circle"};
        
        if(fileToBeImported.bankNumber !== props.account.bank_id){
            return Object.assign(errorMessage, {"message": "Banco diferente."})
        }
        
        if(fileToBeImported.accountNumber !== props.account.number){
            return Object.assign(errorMessage, {"message": "Conta diferente."})
        }

        if(fileToBeImported.transactions.filter(i => (i.date >= props.period.start_date && i.date <= props.period.end_date)).length === 0){
            return Object.assign(errorMessage, {"message": "Arquivo não contém lançamentos do período."})
        }

        if(fileToBeImported.transactions.filter(i => (i.date <= props.period.start_date || i.date >= props.period.end_date)).length > 0){
            return Object.assign(waringMessage, {"message": "Lançamentos fora do período não serão importados."})
        }

        return {
            "type": "success",
            "message": "Arquivo OK",
            "icon": "pi-check-circle"
        }
    }

    const readFile = async (file) => {    
        console.log(file.name);
        const fileContet = await parse(file);
        const ofxData = ofx.parse(fileContet);

        const bankNumber = ofxData.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.BANKID;
        const accountNumber = ofxData.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.ACCTID;

        const fileToBeImported = {
            "name": file.name,
            "ofxData": ofxData,
            bankNumber,
            "bankName": ofxData.OFX.SIGNONMSGSRSV1.SONRS.FI.FID,
            accountNumber,
            "transactions": ofxData.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN.map(i => ({
                "id": `${bankNumber}_${accountNumber}_${i.FITID}_${i.DTPOSTED.substring(0, 8)}`,
                "date": `${i.DTPOSTED.substring(0, 4)}-${i.DTPOSTED.substring(4, 6)}-${i.DTPOSTED.substring(6, 8)}`,
                "description": i.MEMO,
                "value": parseFloat(i.TRNAMT.replace(",","."))
            })),
        }

        fileToBeImported.status = analyseFile(fileToBeImported);
        return fileToBeImported;

    }

    const onSelect = async (e) => {
        let _totalSize = totalSize;
        const _filesToBeImported = [].concat(filesToBeImported);

        for(let i = 0; i < (e.files || []).length; i++){    
            const fileToBeImported = await readFile(e.files[i]);
            _filesToBeImported.push(fileToBeImported)
            _totalSize += e.files[i]?.size;
        }
        setFilesToBeImported(_filesToBeImported);
        setTotalSize(_totalSize);
    }

    const onUpload = (e) => {
        let _totalSize = 0;
        e.files.forEach(file => {
            _totalSize += (file.size || 0);
        });

        setTotalSize(_totalSize);
        toast.current.show({severity: 'info', summary: 'Success', detail: 'File Uploaded'});
    }

    const onRemove = (file, callback) => {
        setFilesToBeImported(filesToBeImported.filter(f => f.name !== file.name));
        setTotalSize(totalSize - file.size);
        callback();
    }

    const onClear = () => {
        setFilesToBeImported([]);
        setTotalSize(0);
    }

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize/10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <ProgressBar value={value} displayValueTemplate={() => `${formatedValue} / 1 MB`} style={{width: '300px', height: '20px', marginLeft: 'auto'}}></ProgressBar>
            </div>
        );
    }

    const itemTemplate = (file, props) => {
        const fileToBeImported = filesToBeImported.find(f => f.name === file.name) || {};
        const status = fileToBeImported.status || {};
        return (
            <div className="p-d-flex p-ai-center p-flex-wrap">
                <div className="p-d-flex p-ai-center" style={{marginRight: '10px'}}>
                    <span className="p-d-flex p-dir-col p-text-left p-ml-3">
                        <b>{file.name}</b>
                    </span>
                </div>
                <Tag value={`Banco: ${fileToBeImported.bankNumber} - ${fileToBeImported.bankName}`} severity="default" className="p-px-3 p-py-2"  style={{marginRight: '10px'}}/>
                <Tag value={`Conta: ${fileToBeImported.accountNumber}`} severity="default" className="p-px-3 p-py-2"  style={{marginRight: '10px'}}/>
                <Tag value={`# Linhas: ${(fileToBeImported.transactions || []).length}`} severity="default" className="p-px-3 p-py-2"  style={{marginRight: '10px'}}/>
                <Tag value={status.message} severity={status.type} icon={`pi ${status.icon}`} className="p-px-3 p-py-2"  style={{marginRight: '10px'}}></Tag>
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger p-ml-auto" onClick={() => onRemove(file, props.onRemove)} />
            </div>
        )
    }

    const emptyTemplate = (options) => {
        return (
            <div className="p-d-flex p-ai-center p-dir-col">
                <i className="pi pi-file p-mt-3 p-p-5" style={{'fontSize': '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)'}}></i>
                <span style={{'fontSize': '1.2em', color: 'var(--text-color-secondary)'}} className="p-my-5">Arraste para aqui os arquivos que deseja importar ou clique em <b><span className="pi pi-fw pi-file"></span></b> na barra de ferramentas.</span>
            </div>
        )
    }

    const myUploader = (event) => {
        if(filesToBeImported.filter(f => f.status.type === "danger").length > 0){
            toast.current.show({severity: 'error', summary: 'Error', detail: "Existem arquivos inválidos. Por favor remova-os da lista antes de executar a importação."});
        }
        else {

            const _records = [].concat(props.records);
            filesToBeImported.forEach(fileToBeImported => {
                fileToBeImported.transactions.forEach(transaction => {
                    if(transaction.date >= props.period.start_date 
                        && transaction.date <= props.period.end_date
                        && !_records.find(r => r.id === transaction.id)){
                            transaction.account_id = props.account.id;
                            transaction.period_id = props.period.id;
                            _records.push(transaction);
                    }
                });
            });
            

            props.onUpdate(_records);
            props.onClose();
        }
    }

    const chooseOptions = {icon: 'pi pi-fw pi-file', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined'};
    const uploadOptions = {icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined'};
    const cancelOptions = {icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined'};

    return (
        <>
        <Toast ref={toast}></Toast>
        <Dialog visible={true} onHide={props.onClose} style={{ width: '90vw' }} header="Subir Arquivos Finaceiros (OFX)" modal>
            

            <Tooltip target=".custom-choose-btn" content="Escolher Arquivos" position="bottom" />
            <Tooltip target=".custom-upload-btn" content="Subir" position="bottom" />
            <Tooltip target=".custom-cancel-btn" content="Remover Todos" position="bottom" />

            <div className="card">
                <FileUpload ref={fileUploadRef} name="demo[]" url="https://primefaces.org/primereact/showcase/upload.php" multiple accept="*/*" maxFileSize={1000000}
                    onUpload={onUpload} onSelect={onSelect} onError={onClear} onClear={onClear}
                    headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                    chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} 
                    customUpload uploadHandler={myUploader}/>
            </div>
        </Dialog>
        </>
    )
}